import { IMasterProductItemInfo } from '../../../models/i-master-product-item-info';

/** 注文方法 ID -> 表示名。 */
export const orderMethodNameById = (id?: string) => {
  switch (id) {
    case '10': return '画像を選択しておまかせ';
    case '20': return '簡易レイアウトしておまかせ';
    case '30': return '完全レイアウトして入稿';
    case '40': return '完成画像を入稿';
    default: return id || '';
  }
};

// 商品記載情報の type/option ペア。masterProductItemInfo + (productNameId, categoryId) から導出。
// ロジックは api-description-info.ts の apiDescriptionInfoThunk と同じ(API 経由ではなくマスタ XML から直接引く)。
type DescriptionInfoType = { type: string, option: string };

/**
 * 商品記載情報の type/option ペアを masterProductItemInfo から導出する。
 * goods(productNameId) 単位を優先し、無ければ category 単位でフォールバックする。
 */
export const getDescriptionInfoTypes = (
  masterProductItemInfo: IMasterProductItemInfo | null,
  productNameId: string | undefined,
  categoryId: string | undefined,
): DescriptionInfoType[] => {
  if (!masterProductItemInfo) return [];
  const arr: DescriptionInfoType[] = [];
  // 1. goods (productNameId) 単位を優先
  if (productNameId) {
    masterProductItemInfo.lnwMasterProductItemInfo.productItemInfoInput?.forEach((goodsData) => {
      goodsData.productItemInfoInputData?.forEach((data) => {
        if (data.data?.find((vv) => vv.$.goodsID === productNameId)) {
          // type 単位で dedupe (api-description-info の仕様に合わせる)
          if (!arr.find((a) => a.type === data.$.type)) {
            arr.push({ type: data.$.type || '', option: data.$.option || '' });
          }
        }
      });
    });
  }
  // 2. goods で見つからなければ category で fallback
  if (!arr.length && categoryId) {
    masterProductItemInfo.lnwMasterProductItemInfo.productItemInfoInputCategory?.forEach((categoryData) => {
      categoryData.productItemInfoInputCategoryData?.forEach((data) => {
        if (data.data?.find((vv) => vv.$.categoryID === categoryId)) {
          if (!arr.find((a) => a.type === data.$.type)) {
            arr.push({ type: data.$.type || '', option: data.$.option || '' });
          }
        }
      });
    });
  }
  return arr;
};

// 本身 - 付加情報系のラベル判定。visibleCondition.ts の op01b_additionalInfo_single / _single2 / _single3 / _multi ルールを実装。
// 注文作成画面の `display.additional / additional2 / additional3 / additionalMulti` と同じ条件で
// 1 つのラベル(見返し選択 / 台紙貼り / テープ選択 / 付加情報)を返す。該当なしは null。
export const getAdditionalInfoLabel = (
  hasAdditionalInfos: boolean,
  categoryId: string | undefined,
  goodsId: string | undefined,
  productType: string | undefined,
): '見返し選択' | '台紙貼り' | 'テープ選択' | '付加情報' | null => {
  if (!hasAdditionalInfos) return null;
  // 付加情報 (multi): category == jp0328
  if (categoryId === 'jp0328') return '付加情報';
  // テープ選択: category == jp0491
  if (categoryId === 'jp0491') return 'テープ選択';
  // 台紙貼り: (category != jp0491) && (product_type == jptg300162 OR category == jp0393 OR goods_id == jptg301599)
  if (productType === 'jptg300162' || categoryId === 'jp0393' || goodsId === 'jptg301599') return '台紙貼り';
  // 見返し選択: それ以外の組み合わせ + 一連の goods_id 除外
  const excludedGoods = new Set(['jptg300162', 'jptg301763', 'jptg301764', 'jptg301765', 'jptg301599']);
  if (categoryId === 'jp0328' || categoryId === 'jp0393' || categoryId === 'jp0491') return null;
  if (goodsId && excludedGoods.has(goodsId)) return null;
  return '見返し選択';
};
